import React from "react";
import { Link } from "react-router-dom";
import { authAPI } from "../services/api";
import "./VerificationEmailModal.scss";

function VerificationEmailModal({ email, onClose, onResend }) {
  const [resending, setResending] = React.useState(false);
  const [resendSuccess, setResendSuccess] = React.useState(false);
  const [resendError, setResendError] = React.useState("");

  const handleResend = async () => {
    setResending(true);
    setResendError("");
    setResendSuccess(false);

    try {
      const response = await authAPI.resendVerification(email);
      if (response.data.success) {
        setResendSuccess(true);
        if (onResend) onResend();
      } else {
        setResendError(response.data.message || "Failed to resend email");
      }
    } catch (err) {
      setResendError(err.response?.data?.message || "Failed to resend verification email");
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="verification-modal-overlay" onClick={onClose}>
      <div className="verification-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="verification-modal-close" onClick={onClose}>
          ×
        </button>
        <div className="verification-modal-icon">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="32" fill="url(#gradient)" />
            <path d="M20 24L32 32L44 24M20 24L20 40L44 40L44 24M20 24L32 32" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
            <defs>
              <linearGradient id="gradient" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
                <stop stopColor="var(--primary)" />
                <stop offset="1" stopColor="var(--secondary)" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <h2>Check Your Email</h2>
        <p className="verification-modal-message">
          We've sent a verification email to <strong>{email}</strong>
        </p>
        <p className="verification-modal-instructions">
          Please click the verification link in the email to activate your account and start applying to jobs.
        </p>
        {resendSuccess && (
          <div className="verification-modal-success">
            ✓ Verification email sent successfully!
          </div>
        )}
        {resendError && (
          <div className="verification-modal-error">
            {resendError}
          </div>
        )}
        <div className="verification-modal-actions">
          <button 
            className="verification-modal-resend" 
            onClick={handleResend}
            disabled={resending || resendSuccess}
          >
            {resending ? "Sending..." : resendSuccess ? "Email Sent!" : "Resend Verification Email"}
          </button>
          <Link to="/login" className="verification-modal-login">
            Go to Login
          </Link>
        </div>
        <p className="verification-modal-note">
          Didn't receive the email? Check your spam folder or try resending.
        </p>
      </div>
    </div>
  );
}

export default VerificationEmailModal;
